import React, { useState } from "react";
import axios from "axios";
import "./ForgetPassword.css";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import blueLock from "../../assets/images/auth/Untitled-1.svg";
import { useTranslation } from "../../contexts/TranslationContext";
import { axiosPost } from "../../utils/apis/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ForgetPassword = ({ url }) => {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const { t } = useTranslation();

  // const sendEmail = async () => {
  //   if (!email) {
  //     alert(t("ErrorSendingEmail"));
  //     return;
  //   }

  //   try {
  //     const formData = new FormData();
  //     formData.append("cmd", "frappe.core.doctype.user.user.reset_password");
  //     formData.append("user", email);
  //     formData.append("send_code", "true");

  //     const response = await axios.post(url, formData);

  //     if (response.status === 200) {
  //       navigate(`/newpassword/${email}`);
  //     }
  //   } catch (error) {
  //     console.error(t("ErrorSendingEmail"), error);
  //   }
  // };



  const sendResetRequest = async () => {
    if (!identifier) {
      alert(t("PleaseEnterYourEmailOrPhone"));
      return;
    }

    try {
      const apiUrl = "https://crm.alltimestravels.com/api/method/alltimes.www.auth.request_password_reset";

      const requestBody = {};
      if (/^\+?\d+$/.test(identifier)) {
        requestBody.phone = identifier;
      } else {
        requestBody.email = identifier;
      }

      const response = await axiosPost(apiUrl, requestBody);

      if (response.status === 200) {
        // navigate("/newpassword", { state: { userIdentifier: identifier } });
        navigate(`/newpassword/${encodeURIComponent(identifier)}`);
      }
    } catch (error) {
      console.error(t("ErrorSendingResetRequest"), error);
       toast.error(t("ErrorSendingResetRequest"));
    }

  };

  return (
    <div className="auth">
      <div className="check-email-container">
        <Container>
          <div className="forget-password-image">
            <img src={blueLock} alt="Lock" />
          </div>
          {/* <input
            type="email"
            className="login-field user-field mt-4"
            placeholder={t("EnterYourEmail")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          /> */}

          <input type="text" className="login-field user-field mt-4" placeholder={t("PleaseEnterYourEmailOrPhone")} value={identifier} onChange={(e) => setIdentifier(e.target.value)} />

          {/* <input
            type="tel"
            className="login-field user-field mt-4"
            placeholder={t("EnterYourPhone")}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          /> */}

          <button className="login-submit" onClick={sendResetRequest}>
            {t("Submit")}
          </button>
        </Container>
      </div>
      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
    </div>
  );
};

export default ForgetPassword;




